export type ApiResponseDataTransformer<ApiResponseT = any, TransformResultT = any> = (data: ApiResponseT) => TransformResultT;

export const classicApiResponseDataTransformer = (data: any) => data;

export const zedApiResponseDataTransformer = (data: any) => data.value;